export const moduleCategoryConstants = {
    // GET LIST: 列表清單用
    GET_LIST_REQUEST: 'MODULE_CATEGORY_GET_LIST_REQUEST',
    GET_LIST_SUCCESS: 'MODULE_CATEGORY_GET_LIST_SUCCESS',
    GET_LIST_FAILURE: 'MODULE_CATEGORY_GET_LIST_FAILURE',
    RESET_LIST_SUCCESS: 'MODULE_CATEGORY_RESET_LIST_SUCCESS',
};